import React from 'react'
import UpdateDefectForm from '../../../component/form/master/defect/UpdateDefectForm'

export default function UpdateDefect() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <UpdateDefectForm />
                    </div>
                </div>
            </div>
        </>
    )
}
